import {Component, OnInit, ViewChild} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {FormsModule} from '@angular/forms';
import {GeoAnaliseService} from '../../../../../app-core/service/refatorar/geo-analise.service';
import {UiModule} from '../../../../../app-core/utils/ui/ui.module';
import {MaterialInputComponent} from '../../../../../app-core/utils/components/material-input/material-input.component';
import {UiModalComponent} from '../../../../../app-core/utils/ui/components/complex/ui-modal/ui-modal.component';
import {UploadFilesComponent} from '../../../../../app-core/utils/components/upload-files/upload-files.component';
import {AffectedArea} from '../../../../../app-core/dto/sigevs/sanitary-analysis.model';
import {AffectedAreaService} from '../../../../../app-core/service/sigevs/affected-area.service';
import {lastValueFrom} from 'rxjs';

@Component({
    selector: 'app-upload-shapes',
    templateUrl: './shape-upload.component.html',
    imports: [
        FormsModule,
        UiModule,
        MaterialInputComponent,
        UploadFilesComponent
    ],
    styleUrls: ['./shape-upload.component.scss']
})
export class ShapeUploadComponent implements OnInit {
    loading = false;
    loadingShapes = false;

    nome: string;
    shape: any;
    affectedAreas: AffectedArea[];

    @ViewChild(UiModalComponent) modal: UiModalComponent;
    @ViewChild(UploadFilesComponent) filesInput: UploadFilesComponent;

    constructor(private affectedAreaService: AffectedAreaService, private toast: ToastrService,) {
    }

    async ngOnInit() {
        await this.loadShapes();
    }

    onFileSelected(files: File[]) {
        const file: File = files[0];

        if (file) {
            const reader = new FileReader();
            const fileName = file.name;
            this.nome = fileName.substring(0, fileName.lastIndexOf('.'));
            reader.onload = (e) => {
                console.log(reader)
                try {
                    const jsonData = JSON.parse(reader.result as string);
                    this.shape = jsonData;
                } catch (error) {
                    console.error('Error parsing JSON file:', error);
                    this.toast.error("Erro ao importar shape", "ERRO");
                }
            };
            reader.readAsText(file);
        }
    }

    async submit() {
        let formagoGeo: AffectedArea = {
            name: this.nome,
            shape: this.shape
        } as AffectedArea;

        try {
            this.loading = true;

            const response = await lastValueFrom(this.affectedAreaService.save(formagoGeo));

            if (response.status === 'SUCCESS') {
                this.toast.success("Shape importado com sucesso", "SUCESSO");
            }

            this.resetFileInput();
            await this.loadShapes();
        } catch (e) {
            throw e;
        } finally {
            this.loading = false;
            this.filesInput.clearFiles();
        }
    }

    resetFileInput() {
        this.shape = null;
        this.nome = null;
        const fileInputElement = document.getElementById('fileInput') as HTMLInputElement;
        if (fileInputElement) {
            fileInputElement.value = '';
        }
    }

    showModal() {
        this.modal.showModal();
    }

    async loadShapes() {
        try {
            this.loadingShapes = true;

            const response = await lastValueFrom(this.affectedAreaService.findAllWithoutShape());
            this.affectedAreas = response.data;

        } catch (e) {
            throw e;
        } finally {
            this.loadingShapes = false;
        }
    }

    async downloadShape(area: AffectedArea) {
        try {
            area['loading'] = true;

            const response = await lastValueFrom(this.affectedAreaService.findById(area.id));

            if (response.status === 'SUCCESS') {
                const payload = response?.data?.shape ?? '{}';
                const json = JSON.stringify(payload, null, 2);
                const blob = new Blob([json], { type: 'application/json' });
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${area.name || 'shape'}.json`;
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            }
        } catch (e) {
            throw e;
        } finally {
            area['loading'] = false;
        }
    }
}
